import { Box, Typography } from "@mui/material";
import { useState, useEffect, useCallback } from "react";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import dashboardAtoms, { fetchBlocks, fetchMapRender, } from "../../../../atoms/Dashboard/DashboardAtom";
import LayoutComponent from "../../../dashboard/Layout";
import settingsAtom from "../../../../atoms/settings/SettingsAtom";
import ToggleButtonComponent from "../../../../shared/Dashboard/ToogleButton";
import LockUnlockRightPanel from "./rightPanel";



const Mapview = () => {
    const projectId = localStorage.getItem("project_id");
    const navigate = useNavigate();
    const [data] = useAtom(dashboardAtoms);
    const [settings] = useAtom(settingsAtom);
    const [, setMap] = useAtom(fetchMapRender)
    const [, setBlocks] = useAtom(fetchBlocks);
    const [selectPart, setSelectPart] = useState([])
    const [loader, setLoader] = useState(false)
    const [view, setView] = useState("Lock/Unlock");
    const [selectBlock, setSelectBlock] = useState(false);
    const [isSelect, setIsSelect] = useState(false);


    const fetchAllData = useCallback(async () => {
        setLoader(true)
        try {
            await Promise.allSettled([
                setBlocks(''),
                setMap(''),
            ]);
        } catch (error) {
            console.error("Error in fetchAllData:", error);
        } finally {
            setLoader(false)
        }
        // eslint-disable-next-line
    }, [setBlocks, setMap]);

    useEffect(() => {
        if (projectId) {
            fetchAllData();
        }
    }, [projectId, fetchAllData]);

    useEffect(() => {
        if (view === "Logs") {
            navigate("/quality/logs-and-checklists")
        }
        // eslint-disable-next-line
    }, [view])

    return (
        <Box sx={{ height: 'calc(100vh - 200px)', width: "100%", p: 0 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "start", py: 2, px: 2 }}>
                <Typography variant="span" fontSize={22} sx={{ fontWeight: "bold" }}>
                    Lock and Unlock</Typography>
                <ToggleButtonComponent
                    data={["Lock/Unlock", "Logs"]}
                    active={view}
                    setActive={setView}
                />
            </Box>
            <Box px={4} sx={{ borderTop: '1px solid #e0e0e0', display: "flex" }}>
                <Box sx={{ width: "70%", borderRight: '1px solid #e0e0e0' }}>
                    {loader ?
                        <Box sx={{
                            height: 'calc(100vh - 200px)',
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <CircularProgress />
                        </Box>
                        : <LayoutComponent
                            svgMap={data?.svgMap}
                            loader={loader}
                            blocks={data?.blocks}
                            list={data?.list}
                            projectList={settings?.projectList}
                            selectBlock={selectBlock}
                            setSelectBlock={setSelectBlock}
                            selectPart={selectPart}
                            setSelectPart={setSelectPart}
                            isSelect={isSelect}
                            setIsSelect={setIsSelect}
                            type="lock"
                        />
                    }
                </Box>
                <Box sx={{ width: '30%' }} p={2}>
                    <LockUnlockRightPanel
                        isSvg={true}
                        active=""
                        scope=""
                        type="lock/unlock"
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default Mapview;